import { render, staticRenderFns } from "./SignupWizard.vue?vue&type=template&id=2198d704&scoped=true&"
import script from "./SignupWizard.vue?vue&type=script&lang=js&"
export * from "./SignupWizard.vue?vue&type=script&lang=js&"
import style0 from "./SignupWizard.vue?vue&type=style&index=0&id=2198d704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198d704",
  null
  
)

export default component.exports